import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function NeteANuestraIniciativa() {
  return <section data-section-id="262755" id="únete-a-nuestra-iniciativa" className="bg-primary text-primary-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 text-center flex flex-col items-center">
        <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-lg bg-primary-foreground/10">
          <Phone className="h-8 w-8 text-primary-foreground" />
        </div>
        
        <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-white">
          Únete a Nuestra Iniciativa
        </h2>
        
        <p className="font-default text-lg md:text-xl mb-8 max-w-2xl mx-auto text-primary-foreground/90">
          Forma parte del cambio en la industria del acero. Estamos buscando socios estratégicos y colaboradores comprometidos con la excelencia y la innovación sostenible.
        </p>
        
        <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:brightness-110 transition-all duration-300 rounded-md h-14 px-8 text-lg font-bold shadow-md">
          <Link to="/NosotrosPage">
            <Phone className="mr-2 h-5 w-5" />
            Contáctanos Ahora
          </Link>
        </Button>
        
        <p className="mt-4 text-sm text-primary-foreground/80 font-default">
          Atención personalizada para proyectos industriales de gran escala.
        </p>
      </div>
    </section>;
}